import { useAuth } from 'context/AuthProvider';
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Form, FormGroup, Input, Label } from 'reactstrap'
import { apiDepartamentosService } from 'services/apiDepartamentosService';
import { apiexportacionService } from 'services/apiExportacionService';

const ExportadorHorasExtra = () => {
    const { empresa } = useAuth();
    const [departamentos, setDepartamentos] = useState([]);

    const [departamentoId, setDepartamentoId] = useState("Todos");
    const [anno, setAnno] = useState(new Date().getFullYear());
    const [mes, setMes] = useState("Todos");

    const handleSubmit = async (e) => {
        e.preventDefault();
        await apiexportacionService.getHorasExtraMes(empresa.id, anno, mes, departamentoId, null)

    }

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiDepartamentosService.getAll(empresa.id, 0, 1000);
            setDepartamentos(response.content)
        }
        fetchData();
    }, [empresa])


    return (
        <>
            <Card className='shadow'>
                <Form onSubmit={handleSubmit}>
                    <CardHeader>
                        Listado de horas extra
                    </CardHeader>

                    <CardBody>

                        <FormGroup row>
                            <Col>
                                <Label for='departameto'>departameto:</Label>

                                <Input type="select" name="select" id="departameto" value={departamentoId} onChange={(e) => setDepartamentoId(e.target.value)}>
                                    <option value={"Todos"}>Todos los departamentos</option>
                                    {departamentos.map((departamento, index) => (
                                        <option key={index} value={departamento.id}>{departamento.nombre}</option>
                                    ))}
                                </Input>
                            </Col>
                            <Col>
                                <Label for='anno'>Año:</Label>
                                
                                  <Input className="form-control-alternative" type="number" id="year" name="year" min="1900" max="2100" step="1" value={anno} onChange={(e) => setAnno(e.target.value)} />
                            </Col>
                            <Col>
                                <Label for='mes'>Mes:</Label>
                                <Input type="select" name="select" id="mes" value={mes} onChange={(e) => setMes(e.target.value)}>
                                    <option value={"Todos"}>Todos</option>
                                    <option value={1}>Enero</option>
                                    <option value={2}>Febrero</option>
                                    <option value={3}>Marzo</option>
                                    <option value={4}>Abril</option>
                                    <option value={5}>Mayo</option>
                                    <option value={6}>Junio</option>
                                    <option value={7}>Julio</option>
                                    <option value={8}>Agosto</option>
                                    <option value={9}>Septiembre</option>
                                    <option value={10}>Octubre</option>
                                    <option value={11}>Noviembre</option>
                                    <option value={12}>Diciembre</option>
                                </Input>
                            </Col>
                        </FormGroup>


                    </CardBody>

                    <CardFooter className='text-center'>
                        <Button color="success" type='submit'>Descargar</Button>
                    </CardFooter>
                </Form>
            </Card>
        </>

    )
}

export default ExportadorHorasExtra